import apiClient from "./client";
import { getUser, saveAuth } from "./auth";

export const profileApi = {
  // Supplies the WhatsApp number a signed-in user does not yet have. Returns
  // { needsPhone: false } on success.
  completeProfile: (data) =>
    apiClient.post("/api/auth/complete-profile", data, { authRequired: true }),
};

// The stored user is what ProfileGuard reads on every route change, so it has
// to be updated in place once the number is supplied — otherwise the guard
// keeps redirecting to a screen the user has already finished.
export const markPhoneProvided = () => {
  const token = localStorage.getItem("sc_token");
  const user = getUser();
  if (!token || !user) return;
  saveAuth(token, { ...user, needsPhone: false });
};
